import { Accordion, AccordionDetails, AccordionSummary, Alert, Button, Checkbox, Container, Divider, FormControlLabel, FormGroup, Paper, Snackbar, Stack, TextField, Typography } from "@mui/material";
import { Box } from "@mui/system";
import React, { useState, useEffect, useRef } from "react";
import api from "../api";
import { useGetCompany, useUpdateCompany } from "../api/company";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
const SettingsView = (props) => {

    const [settings, setSettings] = useState({})

    const { data: settingsData, isFetching } = useGetCompany();
    const { mutateAsync, isError, isLoading, isSuccess, reset } = useUpdateCompany();




    useEffect(() => {
        if (settingsData) {
            setSettings(settingsData)
        }
    }, [settingsData])

    const updateData = async (e) => {
        e.preventDefault();
        mutateAsync(settings)
    }

    return (
        <Container maxWidth={"xl"} sx={{ pt: 2, pb: 2, height: "90%" }}>
            <Typography variant="h1" textAlign={"center"} sx={{ pb: 1 }} >Paramètres</Typography>

            <Accordion sx={{ my: 2 }}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    Paramètres de l'entreprise
                </AccordionSummary>
                <AccordionDetails>
                    <Stack spacing={2}
                        component="form"
                        onSubmit={updateData}
                    >
                        <TextField
                            label="Nom de l'entreprise"
                            value={settings.name || ""}
                            onChange={(e) => setSettings({ ...settings, name: e.target.value })}
                        />
                        <TextField
                            label="Email d'administration"
                            value={settings.send_punch_entry_to || ""}
                            onChange={(e) => setSettings({ ...settings, send_punch_entry_to: e.target.value })}
                            type="email"
                        />
                        <FormGroup>
                            <FormControlLabel
                                control={<Checkbox
                                    checked={settings.want_punch_entry_notification || false}
                                    onChange={(e) => setSettings({ ...settings, want_punch_entry_notification: e.target.checked })}
                                />
                                }
                                label="Envoyer une notification à chaque entrée d'un employé" />
                        </FormGroup>
                        <FormGroup>
                            <FormControlLabel
                                control={<Checkbox
                                    checked={settings.show_outliers || false}
                                    onChange={(e) => setSettings({ ...settings, show_outliers: e.target.checked })}
                                />
                                }
                                label="Afficher les temps atypiques" />
                        </FormGroup>
                        <Divider sx={{ my: 2 }} />

                        <Button variant="contained" sx={{ float: "right" }} type="submit" color="success">Appliquer</Button>
                    </Stack>
                </AccordionDetails>
            </Accordion>

            <Snackbar anchorOrigin={{ vertical: "bottom", horizontal: "center" }} onClose={() => reset()} open={isError} autoHideDuration={6000} message="Erreur lors de la sauvegarde des paramètres" >
                <Alert onClose={() => reset()} severity="error">Erreur lors de la sauvegarde des paramètres</Alert>
            </Snackbar>
            <Snackbar anchorOrigin={{ vertical: "bottom", horizontal: "center" }} onClose={() => reset()} open={isSuccess} autoHideDuration={6000} message="Paramètres sauvegardés" >
                <Alert onClose={() => reset()} severity="success">Paramètres sauvegardés</Alert>
            </Snackbar>
        </Container>
    )
}
export default SettingsView